import { createFileRoute } from '@tanstack/react-router';
import { MemberListPage } from '@/pages/chain/MemberListPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional(),
	search: z.string().optional(),
	status: z.enum(['ACTIVE', 'INACTIVE']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/chain/members')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainHq.read', 'chainHq.readAnalytics'], redirectTo: '/dashboard' }),
	validateSearch: searchSchema,
	component: MemberListPage,
});
